import { render, staticRenderFns } from "./store-group-penalty-tab.vue?vue&type=template&id=3857a28e&scoped=true"
import script from "./store-group-penalty-tab.vue?vue&type=script&lang=js"
export * from "./store-group-penalty-tab.vue?vue&type=script&lang=js"
import style0 from "./store-group-penalty-tab.vue?vue&type=style&index=0&id=3857a28e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3857a28e",
  null
  
)

export default component.exports